import { AddShoppingCartItemDTO, ShoppingCartItemDTO } from '@ringo/shared'
import { useShoppingCartApi } from '../../common/api-context'
import { useUser } from '../../common/hooks/auth/useUser'
import Modal from '../common/modal/modal'
import { downloadBlob } from '../../common/helpers/fileHelper'
import Button from '../common/button'

export function Dev({ isOpen, setIsOpen }: { isOpen: boolean; setIsOpen: (val: boolean) => void }) {
    const shoppingCartApi = useShoppingCartApi()
    const { user } = useUser()

    const downloadShoppingCartForPriceMonitor = async () => {
        if (!user?.id) return

        const shoppingCart = (await shoppingCartApi.getShoppingCart()).data
        const blob = new Blob([JSON.stringify({ userId: user.id, items: shoppingCart.shoppingCartItems?.map(mapShoppingCartItemToAddDTO) ?? [] })], {
            type: 'application/json',
        })
        downloadBlob(blob, `Price monitor request - ${user.email}.json`)
    }

    return (
        <Modal open={isOpen} title={'DEV Mode'} onClose={() => setIsOpen(false)} dialogClass="overflow-y-auto overflow-x-hidden p-2">
            <div className="border radius-md p-2 mt-2">
                <div>Price Monitor</div>
                <Button text={'Download price monitor request'} type={'squareYellow'} onClick={downloadShoppingCartForPriceMonitor}></Button>
            </div>
        </Modal>
    )
}

/**
 * Maps a ShoppingCartItemDTO (Single or Pair) into AddShoppingCartItemDTO
 * @param {Object} item - ShoppingCartItemDTO instance
 * @returns {Object} AddShoppingCartItemDTO
 */
function mapShoppingCartItemToAddDTO(item: ShoppingCartItemDTO): AddShoppingCartItemDTO {
    if (!item || !item.type) {
        throw new Error('Invalid ShoppingCartItemDTO: missing type')
    }

    const base = {
        commissionNumber: item.commissionNumber || undefined,
        note: item.note || undefined,
        replaceItemId: item.id || undefined,
    }

    if (item.type === 'SINGLE_ITEM') {
        return {
            ...base,
            quantity1: item.quantity ?? 1,
            quantity2: 0,
            ring: { ...item.singleRing },
            favoriteName1: item.favoriteName,
            favoriteName2: undefined,
        }
    } else if (item.type === 'PAIR_ITEM') {
        return {
            ...base,
            quantity1: item.quantity1 ?? 1,
            quantity2: item.quantity2 ?? 1,
            ring: { ...item.pairRing },
            favoriteName1: item.favoriteName1 || undefined,
            favoriteName2: item.favoriteName2 || undefined,
        }
    } else {
        throw 'Unsupported item type'
    }
}
